import { render, staticRenderFns } from "./NSDSBill.vue?vue&type=template&id=297bb876&scoped=true"
import script from "./NSDSBill.vue?vue&type=script&lang=js"
export * from "./NSDSBill.vue?vue&type=script&lang=js"
import style0 from "./NSDSBill.vue?vue&type=style&index=0&id=297bb876&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297bb876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297bb876')) {
      api.createRecord('297bb876', component.options)
    } else {
      api.reload('297bb876', component.options)
    }
    module.hot.accept("./NSDSBill.vue?vue&type=template&id=297bb876&scoped=true", function () {
      api.rerender('297bb876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Balance/NSDSBill.vue"
export default component.exports